module.exports = __webpack_public_path__ + "img/petek-design.d0712dae.jpg";